import Layout from '@/views/layout/Layout'
const industryNewsRouter = {
    path: '/industryNews',
    name: 'industryNews',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 行业信息-行业资讯路由
        {
            path: 'industryInfo',
            name: 'industryInfo',
            component: () => import('@/views/industryNews/industryInfo'),
        },
        // 行业信息-资讯列表路由
        {
            path: 'industryList',
            name: 'industryList',
            component: () => import('@/views/industryNews/industryList'),
        },
        // 行业信息-资讯详情路由
        {
            path: 'industryDetail',
            name: 'industryDetail',
            component: () => import('@/views/industryNews/industryDetail'),
        },
        // 行业信息-展会信息路由
        {
            path: 'exhibitionInfo',
            name: 'exhibitionInfo',
            component: () => import('@/views/industryNews/exhibitionInfo'),
        },
        // 行业信息-展会列表路由
        {
            path: 'exhibitionList',
            name: 'exhibitionList',
            component: () => import('@/views/industryNews/exhibitionList'),
        },
        // 行业信息-展会详情路由
        {
            path: 'exhibitionDetail',
            name: 'exhibitionDetail',
            component: () => import('@/views/industryNews/exhibitionDetail'),
        },
    ]
}
export default industryNewsRouter


// WEBPACK FOOTER //
// ./src/router/modules/industryNews.js